import React from 'react';
import PropTypes from 'prop-types';
import s from './Quote.scss';

const Quote = props => {
  const { smalldesc = '', title = '', author = '' } = props.data;
  const quoteText = smalldesc !== '' ? smalldesc : title;
  return (
    <div className={s.quote}>
      <i className={s.iconFirst} />
      <div className={s.quoteText}>
        <p>{quoteText}</p>
        <h4>{author}</h4>
      </div>
      <i className={s.iconSecond} />
    </div>
  );
};

Quote.propTypes = {
  data: PropTypes.shape({
    title: PropTypes.string,
    smalldesc: PropTypes.string,
    author: PropTypes.string,
  }).isRequired,
};

export default Quote;
